import { handleActions } from 'redux-actions';

import { UPDATE_CANDIDATE } from './types';

export default handleActions({
  [UPDATE_CANDIDATE]: (state, { payload }) => ({ ...payload }),
}, {});
